import SimpleHeader from "../../NewApp/SimpleHeader";
import "../IndexInvesting/IndexInvesting.css";
import book from "../../../assets/girls_and_finances_2025.png";
import BookBlock from "../../reusable/BookBlock/BookBlock";
import Footer from "../../Footer/Footer";

const GirlsAndFinances2025: React.FC = () => (
  <div className="book-wrapper">
    <SimpleHeader onHome={() => window.location.href = '/'} onResources={() => window.location.href = '/resources'} />
    <div className="book-page-title">2025-ից դասերը</div>
    <div className="book-page-description">Գործնական եւ անկեղծ գիրք նրանց համար, ովքեր ցանկանում են կառավարել իրենց գումարը, բայց չունեն ժամանակ, էներգիա կամ 318 բլոգային գրառումների արժանի ուշադրություն։</div>
    <div className="book-page-content">
        <BookBlock
        imageSrc={book}
        imageAlt={'index investing'}
        paragraphs={[
            'Բացահայտեք Girls And Finances-ի 2025 թվականի կարևոր դասերը` մտածելակերպի փոփոխությունը, ազդանշանները և քաջալերումը, ինչպես նաև համակարգերը, որոնք աշխատում են սովորական կյանք ունեցող սովորական մարդկանց համար։', 
            `<a href="http://girlsandfinances.com/girls_and_finances_wrapped_2025.pdf" target="_blank" rel="noopener noreferrer">Ներբեռնել PDF տարբերակը</a>`]}
      />
    </div>
    <Footer></Footer>
  </div>
);

export default GirlsAndFinances2025;